export interface TradeDocsBreakdownLine {
  id: string;
  pin: string;
  usd: string;
}

export interface TradeDocsPinSource {
  id?: number;
  dealRateChangedText?: string;
  sdaAmount?: number;
  sdaDollarAmount?: number;
  transactionUserFiaPins?: Array<{
    userFiaPinId?: number;
    dollarAmountUsed?: number;
    userFiaPin?: { pin?: string };
  }>;
}

function usdCell(amount: number | null | undefined, rateChangedText: string): string {
  if (rateChangedText) {
    return `$(${rateChangedText})`;
  }
  if (!amount) {
    return '-';
  }
  return `$ ${amount}`;
}

export function buildTradeDocsBreakdownLines(trade: TradeDocsPinSource): TradeDocsBreakdownLine[] {
  const rateChangedText = trade.dealRateChangedText || '';
  const lines: TradeDocsBreakdownLine[] = [];
  const pins = trade.transactionUserFiaPins || [];

  pins.forEach((pin, index) => {
    lines.push({
      id: `${trade.id || 0}-pin-${pin.userFiaPinId || index}`,
      pin: pin.userFiaPin?.pin || '',
      usd: usdCell(pin.dollarAmountUsed, rateChangedText),
    });
  });

  if ((trade.sdaAmount || 0) > 0) {
    lines.push({
      id: `${trade.id || 0}-sda`,
      pin: 'SDA',
      usd: usdCell(trade.sdaDollarAmount, rateChangedText),
    });
  }

  return lines;
}

export function tradeDocsPinsAndUsdCopyText(lines: TradeDocsBreakdownLine[]): string {
  return lines.map((line) => `${line.pin}\t${line.usd}`).join('\n');
}
